module.exports = __webpack_public_path__ + "img/img_32360_0_5.7e57bf33.png";